export default {
  all: '全部',
  // 操作按钮
  create: '新增',
  edit: '编辑',
  delete: '删除',
  save: '保存',
  cancel: '取消',
  confirm: '确认',
  submit: '提交',
  failed: '失败',
  reset: '重置',
  search: '搜索',
  query: '查询',
  clear: '清空',
  refresh: '刷新',
  export: '导出',
  import: '导入',
  upload: '上传',
  download: '下载',
  view: '查看',
  back: '返回',
  backToList: '返回列表',
  next: '下一步',
  prev: '上一步',
  close: '关闭',
  closeOthers: '关闭其他',
  closeRight: '关闭右边',
  closeAll: '关闭全部',
  open: '打开',
  expand: '展开',
  collapse: '收起',
  copy: '复制',
  detail: '详情',
  more: '更多',
  cancelSelection: '取消选择',

  // 状态
  statusLabel: '状态',
  active: '启用',
  inactive: '禁用',
  enabled: '已启用',
  disabled: '已禁用',
  normal: '正常',
  loading: '加载中...',
  success: '成功',
  error: '错误',
  warning: '警告',
  info: '信息',
  copySuccess: '复制成功',
  copyFailed: '复制失败',

  // 时间
  createTime: '创建时间',
  updateTime: '更新时间',
  lastLogin: '最后登录',

  // 分页
  total: '共',
  items: '条',
  page: '页',
  pageSize: '每页',
  goTo: '前往',
  totalRecords: '共 {count} 条',
  itemsPerPage: '{size} 条/页',
  retry: '重试',
  to: '至',

  // 其他
  operation: '操作',
  actions: '操作',
  remark: '备注',
  description: '描述',
  name: '名称',
  code: '代码',
  sort: '排序',
  yes: '是',
  no: '否',
  ok: '确定',
  add: '添加',
  noData: '暂无数据',
  unknown: '未知',
  notSpecified: '不指定',
  scheme: '方案',
  selectScheme: '选择方案',
  saveAsScheme: '另存为方案',
  defaultScheme: '默认方案',
  selectAll: '全选',
  loadError: '加载失败',
  loadFailed: '加载失败',
  loadErrorDesc: '数据加载失败，请稍后重试或联系管理员。',
  httpError: {
    unauthorized: '登录已过期，请重新登录',
    forbidden: '权限不足，无法访问',
    notFound: '请求的资源不存在',
    serverError: '服务器错误，请稍后重试',
    requestFailed: '请求失败'
  },
  resetDefault: '重置默认',
  saveAsFilterScheme: '另存为筛选方案',
  pleaseEnterSchemeName: '请输入方案名称',
  savedSchemeWillAppearInDropdown: '保存后可在"选择方案"下拉中找到此方案',
  schemeSavedSuccessfully: '筛选方案保存成功',
  schemeManagement: '方案管理',
  schemeManagementDesc: '管理您的筛选方案，双击方案名称可快速编辑',
  schemeName: '方案名称',
  isDefault: '是否默认',
  setAsDefault: '设为默认',
  systemDefault: '系统默认',
  schemeNameCannotBeEmpty: '方案名称不能为空',
  schemeNameModifiedSuccessfully: '方案名称修改成功',
  defaultSchemeSetSuccessfully: '默认方案设置成功',
  systemDefaultSchemeCannotBeDeleted: '系统默认方案不可删除',
  currentDefaultSchemeCannotBeDeleted: '当前默认方案不可删除',
  schemeDeletedSuccessfully: '方案删除成功',
  usageInstructions: '使用说明',
  doubleClickToEdit: '双击方案名称可直接编辑（系统默认方案除外）',
  onlyOneDefaultScheme: '只能有一个默认方案',
  systemAndCurrentDefaultCannotBeDeleted: '系统默认方案和当前默认方案不可删除',
  clickSetDefaultToChange: '点击设为默认，可以更改默认方案',
  pleaseSelect: '请选择',
  selectPlaceholder: '请选择',
  pleaseInput: '请输入',

  // 筛选方案管理相关
  schemeManage: {
    default: '默认',
    schemeUpdateSuccess: '方案更新成功',
    schemeUpdateError: '方案更新失败',
    schemeSaveSuccess: '方案保存成功',
    schemeSaveError: '方案保存失败',
    schemeNameCannotBeEmpty: '方案名称不能为空',
    systemSchemeCannotEdit: '系统默认方案不可编辑',
    schemeNameUpdateSuccess: '方案名称修改成功',
    schemeNameUpdateError: '方案名称修改失败',
    systemSchemeNoNeedSet: '系统默认方案无需设置',
    schemeNotFound: '方案不存在',
    defaultSchemeSetSuccess: '默认方案设置成功',
    defaultSchemeSetError: '默认方案设置失败',
    systemSchemeCannotDelete: '系统默认方案不可删除',
    currentDefaultCannotDelete: '当前默认方案不可删除',
    schemeDeleteSuccess: '方案删除成功',
    schemeDeleteError: '方案删除失败',
    dataLoadError: '数据加载失败，请手动重试',
    customFilterScheme: '用户自定义筛选方案: {name}'
  },

  // 筛选相关
  filter: {
    title: '筛选条件',
    equal: '等于',
    notEqual: '不等于',
    contains: '包含',
    notContains: '不包含',
    isEmpty: '为空',
    isNotEmpty: '不为空',
    batch: '批量',
    addRemoveConditions: '增减条件',
    fieldSettings: '筛选字段设置',
    autoDetect: '（自动判断）',
    selected: '已选择',
    fields: '个字段',
    pleaseSelect: '请选择',
    pleaseSelectMultiple: '请选择多个',
    pleaseInput: '请输入',
    pleaseInputMultiple: '请输入多个',
    dateRangeStart: '开始日期',
    dateRangeEnd: '结束日期',
    configLoadSuccess: '配置加载成功',
    configLoadError: '配置获取失败',
    schemeLoadError: '方案加载失败',
    filterConfigNotFound: '筛选配置未找到',
    useNewEnumSystem: '使用新枚举系统获取选项'
  },

  // 查询操作符
  queryOperator: {
    eq: '等于',
    ne: '不等于',
    like: '包含',
    not_like: '不包含',
    in: '批量',
    not_in: '不在范围内',
    is_null: '为空',
    is_not_null: '不为空',
    gt: '大于',
    ge: '大于等于',
    lt: '小于',
    le: '小于等于',
    between: '范围',
    not_between: '不在范围',
    date_shortcut: '日期快捷操作'
  },

  // 日期快捷操作
  dateShortcut: {
    this_week: '本周',
    last_week: '上周',
    next_week: '下周',
    this_month: '本月',
    last_month: '上月',
    next_month: '下月',
    this_year: '今年',
    last_year: '去年',
    next_year: '明年',
    today: '今天',
    yesterday: '昨天',
    tomorrow: '明天',
    last_7_days: '过去7天',
    last_30_days: '过去30天',
    last_90_days: '过去90天'
  },

  // 语言设置
  language: {
    current: '当前语言',
    switch: '切换语言',
    chinese: '简体中文',
    english: 'English',
    switchSuccess: '语言切换成功',
    switchError: '语言切换失败'
  },

  // 主题设置
  theme: {
    light: '浅色主题',
    dark: '深色主题',
    auto: '跟随系统'
  },

  // 仪表盘相关
  totalOrders: '总订单数',
  pendingOrders: '待履约',
  inProgressOrders: '履约中',
  completedOrders: '已完结',
  closedOrders: '已关闭',
  compareLastWeek: '同比上周',
  compareYesterday: '较昨日',
  onTimeRate: '准班率',
  satisfaction: '满意度',
  closeRate: '关闭率',
  orderTracking: '订单跟踪',
  businessNodes: '业务节点',
  shippingNodes: '运踪节点',
  todoTasks: '待办任务',
  pendingOrdersLabel: '待处理订单',
  ordersUnit: '单',
  tasksLabel: '任务',
  totalCountLabel: '共 {count} 个订单需要处理',
  searchPlaceholder: '请输入订单号/报价单号/Job号/MBL号/HBL号查询',

  // 业务节点状态
  generateOrder: '生成订单',
  pricing: '运价',
  booking: '订舱',
  trucking: '拖车',
  warehouse: '仓库',
  customs: '报关',
  vgm: 'VGM',
  blSupplement: '提单补料',
  bill: '账单',
  invoice: '发票',
  paymentSlip: '水单',
  billOfLading: '提单',

  // 节点状态
  nodeCompleted: '已完成',
  quoted: '已报价',
  spaceConfirmed: '舱位确认',
  loaded: '已装箱',
  inWarehouse: '已进仓',
  customsCleared: '已报关',
  pendingSubmit: '待提交',
  pendingGenerate: '待生成',
  pendingInvoice: '待开票',
  pendingUpload: '待上传',
  pendingSign: '待签单',
  inProgress: '进行中',
  pendingStart: '待开始',

  // 测试组件相关
  test: {
    component: '测试组件',
    content: '测试内容',
    data: '测试数据',
    componentName: '组件名称',
    createTime: '创建时间',
    status: '状态',
    version: '版本',
    customContent: '自定义内容'
  },

  // 操作动作
  action: {
    refresh: '刷新',
    expand: '展开',
    collapse: '收起',
    cancel: '取消',
    delete: '删除',
    edit: '编辑'
  },

  // 状态扩展
  status: {
    active: '活跃',
    inactive: '非活跃',
    expanded: '已展开',
    collapsed: '已收起'
  },

  // 表格相关
  table: {
    name: '名称',
    type: '类型',
    status: '状态',
    createTime: '创建时间',
    action: '操作',
    data: '表格数据',
    customTable: '自定义表格',
    customTableSettings: '自定义表格设置',
    exportAsExcel: '导出为 Excel',
    exportAsCsv: '导出为 CSV',
    fieldsSelected: '已选择 {selected}/{total} 个字段',
    tableConfigSaveSuccess: '表格配置保存成功',
    tableConfigLoadError: '查询表格配置失败',
    tableConfigSaveError: '保存表格配置失败',
    resetToDefaultSuccess: '已重置为默认配置',
    exportSuccess: '{type} 导出成功',
    exportError: '{type} 导出失败'
  },
  columnScheme: {
    selectPlaceholder: '选择列方案',
    save: '保存列方案',
    saveTitle: '保存表格列方案',
    name: '方案名称',
    namePlaceholder: '请输入列方案名称',
    nameRequired: '请输入列方案名称',
    noColumns: '当前没有可保存的列配置',
    saveSuccess: '列方案保存成功',
    saveError: '列方案保存失败'
  },

  // 确认信息
  confirmMessages: {
    delete: '确定要删除这条记录吗？',
    logout: '确认退出',
    logoutMessage: '确定要退出登录吗？'
  },

  // 消息提示
  message: {
    refreshSuccess: '刷新成功',
    actionSuccess: '操作成功',
    deleteSuccess: '删除成功',
    developmentInProgress: '功能开发中...',
    logoutSuccess: '退出登录成功',
    logoutError: '退出登录失败',
    menuSearch: '请输入菜单名称搜索',
    pleaseCompleteRequiredFields: '请完善必填信息'
  },

  // 用户相关
  user: {
    admin: '管理员',
    profile: '个人信息',
    settings: '账户设置',
    help: '帮助中心',
    logout: '退出登录',
    user: '用户'
  },

  // 菜单标题
  menu: {
    home: '首页',
    dashboard: '仪表盘',
    entrustedOrder: '委托下单',
    controlTowerPanel: '控制塔面板',
    superRates: '超级运价',
    rateManagement: '运价维护',
    fclRates: '整箱运价管理',
    contractManagement: '合约管理',
    surchargeManagement: '附加费管理',
    pricingRuleManagement: '加价规则管理',
    markupRuleMaintenance: '加价规则维护',
    businessMarkupRules: '商务加价规则',
    salesMarkupRuleMaintenance: '销售加价规则维护',
    salesQuotation: '报价记录',
    managementFreight: '运价管理',
    rateWarehouse: '运价库',
    rateWarehouseFcl: '运价库海运整箱',
    rateWarehouseLcl: '运价库海运拼箱',
    rateQuery: '运价查询',
    ecommerceCarrierRates: '船司电商运价',
    ecommerceRates: '电商运价',
    ecommercePriceWatch: '运价监控',
    ecommercePlatformAccount: '船司账号维护',
    ecommerceDailyRates: '今日运价',
    ecommerceSubscription: '每日推送配置',
    biddingManagement: '招投标管理',
    tenderManagement: '招标管理',
    bidManagement: '投标管理',
    inquiryQuotation: '询价报价',
    inquiryManagement: '询价管理',
    quoteManagement: '报价管理',
    spaceQuery: '舱位查询',
    spaceBooking: '舱位预订',
    spaceStatistics: '舱位统计',
    orders: '订单中心',
    orderManagement: '订单管理',
    orderTracking: '状态追踪',
    distributionShipment: '发货申请单',
    settlement: '结算',
    settlementStatement: '结算账单',
    customer: '客商中心',
    waybill: '运单',
    userManagement: '用户管理',
    companyManagement: '企业管理',
    addCompany: '添加企业',
    editCompany: '企业管理',
    roleAuthManagement: '角色权限管理',
    userCenter: '用户中心',
    userProfile: '个人信息',
    companyProfile: '企业信息',
    billingManagement: '计费管理',
    application: '应用中心',
    apiCenter: 'API中心',
    apiList: 'API列表',
    apiSettings: 'API设置',
    systemSettings: '系统设置',
    roleManagement: '角色管理',
    staffManagement: '员工管理',
    permissionManagement: '权限管理',
    departmentManagement: '部门管理',
    postManagement: '岗位管理',
    basicData: '基础资料维护',
    portManagement: '港口管理',
    carrierManagement: '承运人管理',
    countryRegionManagement: '国家（地区）',
    chinaAdministrativeDivision: '行政区划',
    overseasWarehouseManagement: '仓库管理',
    zipcodeManagement: '邮编管理',
    routeManagement: '航线管理',
    containerManagement: '集装箱管理',
    packageUnitManagement: '包装单位',
    transportTermsManagement: '运输条款',
    tradeTermsManagement: '贸易条款',
    currencyManagement: '币种管理',
    exchangeRateManagement: '汇率设置',
    calculationUnitManagement: '计费单位',
    chargeManagement: '费用管理',
    shipAgentManagement: '船舶代理',
    terminalManagement: '码头管理',
    productMaterialData: '产品物料数据',
    componentsDemo: '组件示例',
    examplePage: '示例页面',
    advancedSelectExample: '高级选择组件',
    filterManagement: '筛选方案管理',
    permissionUsage: '权限使用说明',
    shipData: '船舶资料',
    shipDataManagement: '船舶数据管理',
    shippingScheduleCenter: '船期中心',
    lineMaintenance: '航线维护',
    shipSchedule: '船期查询',
    personalizationConfig: '个性化配置',
    companyNews: '公司新闻',
    templateConfig: '模板设置',
    configManagement: '配置管理',
    taskManagement: '任务管理',
    approvalProcess: '流程管理',
    nodeManagement: '节点管理',
    businessManagerConfig: '业务负责人设置',
    supplierQuotationConfig: '供应商报价配置'
  },

  // 视图模式
  viewMode: {
    list: '列表视图',
    card: '卡片视图'
  },

  // 系统相关
  system: {
    name: '控制塔系统',
    brand: 'CargoONE',
    mode: '运营',
    aiAssistant: '智能助手',
    backToPortal: '返回门户首页'
  },

  viewDetail: '查看明细',
  weekdaySeparator: '、',
  dayUnit: '天',
  weekdays: {
    short: {
      1: '周一',
      2: '周二',
      3: '周三',
      4: '周四',
      5: '周五',
      6: '周六',
      7: '周日'
    }
  }
}
